import { useQuery } from "react-query";

import axios from "axios";

import { projectServiceEndpoint } from "api/project";

export const SYSTEM_SHAPEFILES_QUERY_KEYS = {
  systemShapefiles: "systemShapefiles"
};

export type UseSystemShapefilesQueryKeysT = keyof typeof SYSTEM_SHAPEFILES_QUERY_KEYS;
export type UseSystemLevelShapefilesQueryParamsT = {
  onSuccess?: (data) => void;
  onError?: (error) => void;
  select?;
  queryKey?: UseSystemShapefilesQueryKeysT;
};

export type UseSystemShapefilesQueryReturnT = {
  error;
  isError: boolean;
  isIdle: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  refetch: () => void;
  data;
};

async function fetchSystemShapefile() {
  return await axios.get(`${projectServiceEndpoint}/shapefile-node/systemShapefileTree`);
}

export function useSystemShapefilesQuery({
  onSuccess,
  onError,
  select,
  queryKey = "systemShapefiles"
}: UseSystemLevelShapefilesQueryParamsT): UseSystemShapefilesQueryReturnT {
  const queryInfo = useQuery({
    queryKey: [queryKey],
    queryFn: fetchSystemShapefile,
    select,
    onError: (error) => {
      onError && onError(error);
    },
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
    }
  });

  return {
    error: queryInfo.error,
    isError: queryInfo.status === "error",
    isIdle: queryInfo.status === "idle",
    isLoading: queryInfo.status === "loading",
    isSuccess: queryInfo.status === "success",
    refetch: queryInfo.refetch,
    data: queryInfo.data?.data
  };
}
